import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default class BodyScroll {
    constructor() {
        this.body = document.querySelector("body");
        this.scrollPosition = 0;
    }

    lock(el) {
        const lockPaddingValue = window.innerWidth - this.body.offsetWidth + "px";
        
        this.scrollPosition = window.pageYOffset;

        this.body.style.paddingRight = lockPaddingValue;

        this.body.style.top = `-${this.scrollPosition}px`;
        disableBodyScroll(el);
    }

    unLock(timeout = 200) {
        setTimeout(() => {
            this.body.style.removeProperty("top");

            this.body.style.removeProperty("padding-right");

            clearAllBodyScrollLocks();
            
            // window.scroll(0,this.scrollPosition)

            // window.scroll({
            //     top: this.scrollPosition,
            //     left: 0,
            //     behavior: 'smooth'
            // });

        }, timeout);
    }
}